import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { Grid } from 'react-bootstrap';
import Modal from '../../common/Modal/Modal';
import BookingModalsParams from '../BookingModal/BookingModalsParams';
import { FancyWhiteButton } from '../../common/FancyButton/FancyButton';
import analyticsContext from '../../analytics/Analytics';
import partyImg from '../../../resources/react-svg/SHS_Icons__Success.js';
import { theme } from '../../../../../themes';

class BookingSuccessModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      app: 'shs',
    };

    this.partyImgStyles = { color: theme.colors.primaryAccent, width: '62px', height: '67px' };

    this.partnerButtonStyles = {
      backgroundColor: theme.colors.primaryAccent,
      borderColor: theme.colors.primaryAccent,
      color: theme.colors.experiencesCallMeModalButtonTextColor,
    };
  }
  componentDidMount() {
    analyticsContext
      .withAdvancedProps({
        section: 'bookingSuccess',
        mode: this.props && this.props.mode,
        experience: this.props && this.props.megaUseCase,
      })
      .screenEvent();
  }
  getFormattedTime = (time, timezone) => {
    if (!time || !timezone) {
      return '';
    }
    const momentTime = moment.tz(time, timezone);
    return momentTime.format('dddd,') + ' ' + momentTime.format('MMMM Do') + ' at ' + momentTime.format('h:mm A (z)');
  };

  getApptTimeString = (appointmentData) => {
    let customerAppointmentDateTimeString = '';
    if (appointmentData) {
      customerAppointmentDateTimeString = this.getFormattedTime(
        appointmentData.customerAppointmentDateTime,
        appointmentData.timezone
      );
    }
    return customerAppointmentDateTimeString;
  };

  renderCallMeLaterSuccess = () => {
    const callMeLaterModalParams = BookingModalsParams[this.state.app]['callMeLater'].successModal;
    const title = callMeLaterModalParams.title;
    const subtitle = callMeLaterModalParams.subtitle;

    let customerAppointmentDateTimeString = null;
    if (this.props.appointmentData.customerAppointmentDateTime) {
      customerAppointmentDateTimeString = "We'll call you on " + this.getApptTimeString(this.props.appointmentData);
    }

    return (
      <Modal>
        <Grid>
          <div className="successMsgModalContent">
            <div className="partyImg">{partyImg(this.partyImgStyles)}</div>
            <p className="title">{title}</p>
            {customerAppointmentDateTimeString && (
              <p className="customerAppointmentDateTimeString">{customerAppointmentDateTimeString}</p>
            )}
            {subtitle && <p className="subtitle">{subtitle}</p>}
            <a className="btn inGreen" style={this.partnerButtonStyles} onClick={this.props.onClose}>
              Okay
            </a>
          </div>
        </Grid>
      </Modal>
    );
  };

  renderCallMeNowSuccess = () => {
    const callMeNowModalParams = BookingModalsParams[this.state.app]['callMeNow'].successModal;
    const title = callMeNowModalParams.title;
    const customerAppointmentDateTimeString =
      "We'll call you within the next " +
      this.props.maxCustomerWaitTime +
      ' minutes at ' +
      this.props.appointmentData.customerCallbackNumber;

    return (
      <Modal>
        <Grid>
          <div className="successMsgModalContent">
            <div className="partyImg">{partyImg(this.partyImgStyles)}</div>
            <p className="title">{title}</p>
            {customerAppointmentDateTimeString && (
              <div>
                <p className="customerAppointmentDateTimeString">{customerAppointmentDateTimeString}</p>
              </div>
            )}
            <a className="btn inGreen" style={this.partnerButtonStyles} onClick={this.props.onClose}>
              Okay
            </a>
          </div>
        </Grid>
      </Modal>
    );
  };

  render() {
    return this.props.mode === 'callMeLater' ? this.renderCallMeLaterSuccess() : this.renderCallMeNowSuccess();
  }
}

BookingSuccessModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state /*, ownProps*/) => ({
  mode: state.experiences.experienceBookingModal,
  appointmentData: state.experiences.appointmentData,
  maxCustomerWaitTime: state.callMeNow.maxCustomerWaitTime,
  megaUseCase: state.experiences.experienceSelected.megaUseCase,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingSuccessModal));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/BookingSuccessModal/BookingSuccessModal.js